/**
 * Lazy handle on the Redux store.
 *
 * Modules that only need the store inside a callback (Amplify request headers,
 * auth overrides) previously imported `b2b/store` directly, which made them
 * cyclic with it: store -> middleware -> services -> amplify.config -> store.
 * Depending on this leaf module instead removes those back-edges without
 * changing when the store is actually read.
 */
let storeInstance = null;

export const setStoreRef = instance => {
    storeInstance = instance;
};

export const getStoreRef = () => {
    if (!storeInstance) {
        throw new Error('Redux store accessed before b2b/store.js finished initialising.');
    }
    return storeInstance;
};
